/**
 * Shared constants between frontend and backend (Vercel Functions).
 * IMPORTANT: all values here are public (served to the browser).
 * Never put secrets or credentials in this file.
 */

/**
 * Capacidad de cada área, en personas.
 *
 * Esto es un ESPEJO para el cliente: la fuente de verdad es la tabla `areas`
 * de Supabase, que es la que consulta la RPC `create_reservation` al validar
 * el cupo. Si cambia una, hay que cambiar la otra (ver migración 17).
 */
export const CAPACIDADES = {
    'Vereda': 80,
    'Salón': 80,
};

/**
 * Tamaño de grupo admitido en una reserva.
 *
 * El tope vive en CUATRO capas que tienen que coincidir: este constante (que
 * usan el wizard público y el panel de staff), el guard de `api/reservas.js`,
 * el CHECK de la columna `reservations.personas` y el guard de la RPC
 * `create_reservation`. Las dos últimas están en la migración 17; las dos
 * primeras las ata `tests/unit/reservas-personas-parity.test.js`.
 */
export const PERSONAS_MIN = 1;
export const PERSONAS_MAX = 50;

/**
 * Ventana de reserva, en días corridos desde hoy.
 *
 * La usan el wizard público (chips de fecha) y el alta manual de staff. No hay
 * validación de horizonte en el servidor: una fecha más lejana que esto no la
 * ofrece la UI, pero la API la aceptaría.
 */
export const DIAS_MAX_RESERVA = 60;
